export default {
  Logística : [
    "Horario de entrega", "Calendario de entrega", "Fecha Corta",
    "Producto Roto (caja)", "Temperatura de llegada"
  ],
  Calidad : [
    "Producto dañado", "Parásito", "Cuerpo extraño", "Oxidación",
    "Aguado Húmedo", "Fuera de Calibre", "Análisis Microbiológico",
    "Análisis Físico Químico", "Proporciones (receta)", "Podredumbre / Moho",
    "Organolépticos"
  ],
  Packaging : [
    "Producto Roto (envase)", "Impresión fecha caducidad / lote",
    "Envase incorrecto", "Unidades / caja", "Peso neto", "Etiqueta caja"
  ]
};
